import { Reducer, combineReducers } from 'redux'
import { AppState } from './types'
import teamsReducer from './modules/teams'
import sessionReducer from './modules/session'
import settingsReducer from './modules/settings'

const rootReducer: Reducer<AppState> = combineReducers({
  teams: teamsReducer,
  session: sessionReducer,
  settings: settingsReducer,
})

export default rootReducer
